import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { inheritPrimaryColor } from '../colors'
import getContentProps from '../get-content-props'

const NewsSummary = styled(({ date, slug, title, content, maxHeight = '350px', backgroundColor = 'white', ...props }) => {
  return (
    <div {...props}>
      <div css={`max-height: ${maxHeight}; position: relative; overflow: hidden; font-size: 1.15em; line-height: 1.7em; color: rgb(100, 100, 100);`}>
        <Link css={`color: ${inheritPrimaryColor}; text-decoration: none;`} to={`/news/${slug}`}>
          <h1 css={`display: inline-block; ${!content ? 'font-size: 1.4em; ' : ''}font-weight: 400; line-height: 1.15em; margin-bottom: 0px; &:hover { text-decoration: underline }`}>{title}</h1>
        </Link>
        <DateTag>{date.replace('T', ' ')}</DateTag>
        {content && <>
          <div {...getContentProps(content)} />
          <div css={`pointer-events: none; position: absolute; bottom: 0px; right: 0px; left: 0px; height: 100px; background-image: linear-gradient(transparent, ${backgroundColor});`}></div>
        </>}
      </div>

      {content && <Link to={`/news/${slug}`} css={`align-self: center; color: ${inheritPrimaryColor}`}>Read more</Link>}
    </div>
  )
})`
  flex-grow: 1;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`

const DateTag = styled.div`
  color: rgb(170, 170, 170);
  font-size: 0.9em;
  margin-bottom: 1.2em;
`

export default NewsSummary